import { z } from 'zod';

export default z.union([z.literal(''), z.string().email()]);
